import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const WhitepaperDetailPage = lazy(() => import('../pages/reports/whitepaper-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const MarketResearchPage = lazy(() => import('../pages/market-research/page'));
const TrainingPage = lazy(() => import('../pages/training/page'));
const ConsultingPage = lazy(() => import('../pages/consulting/page'));
const AIEmpowermentPage = lazy(() => import('../pages/ai-empowerment/page'));
const NewMediaPage = lazy(() => import('../pages/new-media/page'));
const FinancialConsultingPage = lazy(() => import('../pages/financial-consulting/page'));
const ToolsPage = lazy(() => import('../pages/tools/page'));
const ZhixiDemoPage = lazy(() => import('../pages/tools/zhixi-ai/page'));
const YuexiDemoPage = lazy(() => import('../pages/tools/yuexi/page'));
const YunchakePage = lazy(() => import('../pages/tools/yunchake/page'));
const XundiantongPage = lazy(() => import('../pages/tools/xundiantong/page'));
const FangwenbaoPage = lazy(() => import('../pages/tools/fangwenbao/page'));
const YunshengPage = lazy(() => import('../pages/tools/yunsheng/page'));
const XinjingPage = lazy(() => import('../pages/tools/xinjing/page'));
const CaidunPage = lazy(() => import('../pages/tools/caidun/page'));
const YuncePage = lazy(() => import('../pages/tools/yunce/page'));
const CaseDetailPage = lazy(() => import('../pages/cases/detail/page'));

// ── 市场调研子服务 ──
const IndustryResearchPage = lazy(() => import('../pages/industry-research/page'));
const CompetitorInvestigationPage = lazy(() => import('../pages/competitor-investigation/page'));
const MarketEntryStrategyPage = lazy(() => import('../pages/market-entry-strategy/page'));
const ConsumerInsightsPage = lazy(() => import('../pages/consumer-insights/page'));
const SatisfactionSurveyPage = lazy(() => import('../pages/satisfaction-survey/page'));
const MysteryShopperPage = lazy(() => import('../pages/mystery-shopper/page'));

// ── 企业培训子服务 ──
const LeadershipTrainingPage = lazy(() => import('../pages/leadership-training/page'));
const SalesTrainingPage = lazy(() => import('../pages/sales-training/page'));
const DigitalTrainingPage = lazy(() => import('../pages/digital-training/page'));

// ── 管理咨询子服务 ──
const OrgOptimizationPage = lazy(() => import('../pages/org-optimization/page'));
const PerformanceManagementPage = lazy(() => import('../pages/performance-management/page'));
const CorporateCultureConsultingPage = lazy(() => import('../pages/corporate-culture-consulting/page'));

// ── AI赋能子服务 ──
const DemandForecastingPage = lazy(() => import('../pages/demand-forecasting/page'));
const RPAAutomationPage = lazy(() => import('../pages/rpa-automation/page'));
const AICustomerAcquisitionPage = lazy(() => import('../pages/ai-customer-acquisition/page'));

// ── 新媒体子服务 ──
const MatrixIPPage = lazy(() => import('../pages/matrix-ip/page'));
const PrivateDomainPage = lazy(() => import('../pages/private-domain/page'));
const MarketingOptimizationPage = lazy(() => import('../pages/marketing-optimization/page'));
const CommunicationPage = lazy(() => import('../pages/communication/page'));

// ── 财务咨询子服务 ──
const FinancialCompliancePage = lazy(() => import('../pages/financial-compliance/page'));
const TaxPlanningPage = lazy(() => import('../pages/tax-planning/page'));
const FinancialDigitalizationPage = lazy(() => import('../pages/financial-digitalization/page'));

const NotFound = lazy(() => import('../pages/NotFound'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },

  // ── 六大主服务 ──
  { path: '/services/market-research', element: <MarketResearchPage /> },
  { path: '/market-research', element: <MarketResearchPage /> },
  { path: '/services/training', element: <TrainingPage /> },
  { path: '/training', element: <TrainingPage /> },
  { path: '/services/consulting', element: <ConsultingPage /> },
  { path: '/consulting', element: <ConsultingPage /> },
  { path: '/services/ai-empowerment', element: <AIEmpowermentPage /> },
  { path: '/ai-empowerment', element: <AIEmpowermentPage /> },
  { path: '/services/new-media', element: <NewMediaPage /> },
  { path: '/new-media', element: <NewMediaPage /> },
  { path: '/services/financial-consulting', element: <FinancialConsultingPage /> },
  { path: '/financial-consulting', element: <FinancialConsultingPage /> },

  { path: '/cases', element: <CasesPage /> },
  { path: '/cases/:id', element: <CaseDetailPage /> },
  { path: '/reports', element: <ReportsPage /> },
  { path: '/reports/whitepaper/:id', element: <WhitepaperDetailPage /> },
  { path: '/tools', element: <ToolsPage /> },
  { path: '/tools/yunchake', element: <YunchakePage /> },
  { path: '/tools/zhixi-ai', element: <ZhixiDemoPage /> },
  { path: '/tools/yuexi', element: <YuexiDemoPage /> },
  { path: '/tools/xundiantong', element: <XundiantongPage /> },
  { path: '/tools/fangwenbao', element: <FangwenbaoPage /> },
  { path: '/tools/yunsheng', element: <YunshengPage /> },
  { path: '/tools/xinjing', element: <XinjingPage /> },
  { path: '/tools/caidun', element: <CaidunPage /> },
  { path: '/tools/yunce', element: <YuncePage /> },
  { path: '/about', element: <AboutPage /> },

  // ── 市场调研子服务 ──
  { path: '/services/industry-research', element: <IndustryResearchPage /> },
  { path: '/industry-research', element: <IndustryResearchPage /> },
  { path: '/services/competitor-investigation', element: <CompetitorInvestigationPage /> },
  { path: '/competitor-investigation', element: <CompetitorInvestigationPage /> },
  { path: '/services/market-entry-strategy', element: <MarketEntryStrategyPage /> },
  { path: '/market-entry-strategy', element: <MarketEntryStrategyPage /> },
  { path: '/services/consumer-insights', element: <ConsumerInsightsPage /> },
  { path: '/consumer-insights', element: <ConsumerInsightsPage /> },
  { path: '/services/satisfaction-survey', element: <SatisfactionSurveyPage /> },
  { path: '/satisfaction-survey', element: <SatisfactionSurveyPage /> },
  { path: '/services/mystery-shopper', element: <MysteryShopperPage /> },
  { path: '/mystery-shopper', element: <MysteryShopperPage /> },

  // ── 企业培训子服务 ──
  { path: '/services/leadership-training', element: <LeadershipTrainingPage /> },
  { path: '/leadership-training', element: <LeadershipTrainingPage /> },
  { path: '/services/sales-training', element: <SalesTrainingPage /> },
  { path: '/sales-training', element: <SalesTrainingPage /> },
  { path: '/services/digital-training', element: <DigitalTrainingPage /> },
  { path: '/digital-training', element: <DigitalTrainingPage /> },

  // ── 管理咨询子服务 ──
  { path: '/services/org-optimization', element: <OrgOptimizationPage /> },
  { path: '/org-optimization', element: <OrgOptimizationPage /> },
  { path: '/services/performance-management', element: <PerformanceManagementPage /> },
  { path: '/performance-management', element: <PerformanceManagementPage /> },
  { path: '/services/corporate-culture-consulting', element: <CorporateCultureConsultingPage /> },
  { path: '/corporate-culture-consulting', element: <CorporateCultureConsultingPage /> },

  // ── AI赋能子服务 ──
  { path: '/services/demand-forecasting', element: <DemandForecastingPage /> },
  { path: '/demand-forecasting', element: <DemandForecastingPage /> },
  { path: '/services/rpa-automation', element: <RPAAutomationPage /> },
  { path: '/rpa-automation', element: <RPAAutomationPage /> },
  { path: '/services/ai-customer-acquisition', element: <AICustomerAcquisitionPage /> },
  { path: '/ai-customer-acquisition', element: <AICustomerAcquisitionPage /> },

  // ── 新媒体子服务 ──
  { path: '/services/matrix-ip', element: <MatrixIPPage /> },
  { path: '/matrix-ip', element: <MatrixIPPage /> },
  { path: '/services/private-domain', element: <PrivateDomainPage /> },
  { path: '/private-domain', element: <PrivateDomainPage /> },
  { path: '/services/marketing-optimization', element: <MarketingOptimizationPage /> },
  { path: '/marketing-optimization', element: <MarketingOptimizationPage /> },
  { path: '/services/communication', element: <CommunicationPage /> },
  { path: '/communication', element: <CommunicationPage /> },

  // ── 财务咨询子服务 ──
  { path: '/services/financial-compliance', element: <FinancialCompliancePage /> },
  { path: '/financial-compliance', element: <FinancialCompliancePage /> },
  { path: '/services/tax-planning', element: <TaxPlanningPage /> },
  { path: '/tax-planning', element: <TaxPlanningPage /> },
  { path: '/services/financial-digitalization', element: <FinancialDigitalizationPage /> },
  { path: '/financial-digitalization', element: <FinancialDigitalizationPage /> },

  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/terms', element: <TermsPage /> },

  { path: '*', element: <NotFound /> },
];

export default routes;